export default __webpack_public_path__ + "static/media/madame_detail6.d6c083f2.jpg";